import React, { Fragment } from 'react';
import { Comment } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { AnswerCommentHeader, answerTypes } from '../../components';
import FlagModal from '../../../Flag';

const AnswerComment = ({
    text,
    id,
    createdAt,
    updatedAt,
    createdByUser: {
        firstName,
        lastName,
        specialty,
    } = {},
    ownAnswer: ownComment,
}) => {
    const specialtyName = (specialty && specialty.name) || undefined;

    const actions = (
        <span>
            {!ownComment && <FlagModal commentId={id} content={text} />}
        </span>
    );

    const content = (
        <Fragment>
            <div className="comment-actions">
                <span className="metadata">{specialtyName}</span>
                {actions}
            </div>
            <Comment.Text>{text}</Comment.Text>
        </Fragment>
    );

    const author = `${firstName} ${lastName}`;
    return (
        <Comment id={`comment-${id}`} className="answer-comment view-mode">
            <Comment.Content>
                <div className="answer-header">
                    <AnswerCommentHeader
                        author={author}
                        updatedAt={updatedAt}
                        createdAt={createdAt}
                        type={answerTypes.comment}
                    />
                </div>
                <Comment.Text className="content-full">{content}</Comment.Text>
            </Comment.Content>
        </Comment>
    );
};

AnswerComment.propTypes = {
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    createdByUser: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
    }).isRequired,
    ownAnswer: PropTypes.bool.isRequired,
    updatedAt: PropTypes.string.isRequired,
};

AnswerComment.defaultProps = {};

export default AnswerComment;
